module.exports = __webpack_public_path__ + "img/charging-hub-request.f9dddb15.png";